import { toMoney } from "./toMoney";

export function calculateCart({ cartItems, appliedDiscount, settings, wallet, shippingData }) {
  const itemTotal = toMoney(
    cartItems.reduce((sum, { finalPrice, quantity }) => sum + finalPrice * quantity, 0)
  );
  const itemCount = cartItems.reduce((sum, { quantity }) => sum + quantity, 0)
  let discountAmount = 0;

  if (appliedDiscount && appliedDiscount.discount > 0) {
    discountAmount = toMoney(itemTotal * (appliedDiscount.discount / 100));
    if (appliedDiscount.maxAmount) {
      discountAmount = toMoney(Math.min(discountAmount, appliedDiscount.maxAmount));
    }
  }

  const subtotal = toMoney(itemTotal - discountAmount);
  
  // Calculate shipping cost
  let shipping = 0;
  if (shippingData?.shippingOption) {
    const { shippingOption } = shippingData;
    const isFreeShipping = shippingOption.free_threshold > 0 && subtotal >= shippingOption.free_threshold;
    shipping = isFreeShipping ? 0 : shippingOption.price;
  } else if (settings?.shippingCost) {
    const isFreeShipping = settings.shippingThreshold > 0 && subtotal >= settings.shippingThreshold;
    shipping = isFreeShipping ? 0 : settings.shippingCost;
  }

  let perishable = 0;
  if (cartItems.some(({ perishable }) => perishable)) {
    perishable = settings.perishablePrice;
  };


  const total = toMoney([subtotal, shipping, perishable]
    .reduce((acc, amount) => acc + amount, 0));

  let walletPayment = 0;
  let ccPayment = total;

  if (wallet.balance) {
    walletPayment = toMoney(Math.min(wallet.balance, total));
    ccPayment = toMoney(ccPayment - walletPayment);
  }

  return {
    itemTotal,
    itemCount,
    subtotal,
    discountAmount,
    calculatedShippingCost: shipping,
    perishableAmount: perishable,
    total,
    paymentTotals: {
      wallet: walletPayment,
      cc: ccPayment,
    },
  };
}

